
import React, { useState, useRef } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Button,
    Popover,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ScheduleIcon from "@mui/icons-material/Schedule";
import CheckIcon from "@mui/icons-material/Check";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {useTheme} from '@mui/material/styles';
import { LayoutFieldModel } from '../../models/models';
import { DateTimeField } from "@mui/x-date-pickers/DateTimeField";
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { TimeClock } from '@mui/x-date-pickers/TimeClock';
import { TimeView } from '@mui/x-date-pickers';
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { formatTime } from "../../utils/dateFunctions";
import dayjs from 'dayjs';

export const DateTimeFieldComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: string,
  onChange: (value: Date, layoutField: LayoutFieldModel) => void,
}> = ( {
  layoutField,
  value,
  onChange
}) => {

  const initValue = () => {
    if(value !== null) return new Date(value)
//    if(layoutField.ReferencedField_sys.DefaultValue_sys !== null) return new Date(layoutField.ReferencedField_sys.DefaultValue_sys)
    if(!layoutField.ReferencedField_sys.DefaultValue_sys) return new Date()
    if(!layoutField.ReferencedField_sys.DefaultValue_sys.type) return new Date()
    if(layoutField.ReferencedField_sys.DefaultValue_sys.value === null) return new Date()
    if(layoutField.ReferencedField_sys.DefaultValue_sys.type === 'constant') return new Date(layoutField.ReferencedField_sys.DefaultValue_sys.value)
    if(layoutField.ReferencedField_sys.DefaultValue_sys.type === 'backend_function') return new Date()
    if(layoutField.ReferencedField_sys.DefaultValue_sys.type === 'frontend_function') return new Date() //TODO: calculate frontend function


    return new Date()
  }

  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date>(initValue());
  const [timeView, setTimeView] = useState<TimeView>('hours');
  const anchorRef = useRef<HTMLDivElement | null>(null);

  const openCalendar = (event: React.MouseEvent<HTMLElement>) => {
    setOpen(true);
  }

  const closeCalendar = () => {
    setOpen(false);
    const value = new Date(selectedDate);
    onChange(value, layoutField);
  }

  const changeTimeView = () => {
    setTimeView('hours');
  }

  const changeDate = (date: Date) => {
    const value = new Date(date);
    setSelectedDate(value);
  }

  const changeTime = (date: Date) => {
    if(timeView === 'hours'){
      setTimeView('minutes')
    }
    const value = new Date(date);
    setSelectedDate(value);
  }

  const handleChange = (newCalendarValue: any) => {
    const value = new Date(newCalendarValue);
    onChange(value, layoutField);
  }

  return (
    <>
        <Box ref={anchorRef}>
         <DateTimeField
            disabled={true}
            variant="filled"
            fullWidth
            label={layoutField.ReferencedField_sys.Label_sys}
            value={dayjs(value)}
            format="DD.MM.YYYY HH:mm"
            onChange={(newCalendarValue: any) => handleChange(newCalendarValue)}
            InputProps={{
              disableUnderline: true,
              endAdornment: (
                layoutField.AccessSetting_sys !== 'read' &&
                <InputAdornment position="end">
                  <IconButton size="small" onClick={(event) => openCalendar(event)}>
                    <ScheduleIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          </Box>

          <Popover
            open={open}
            anchorEl={anchorRef.current}
            onClose={closeCalendar}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Box>

              <DateCalendar
                disabled={layoutField.AccessSetting_sys === 'read'}
                value={dayjs(selectedDate)}
                onChange={(newCalendarValue: any) => changeDate(newCalendarValue)}
              />

              <Box
               sx={{display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"}}
              >
                <Typography>
                  {formatTime(selectedDate)}
                </Typography>

                <IconButton
                   size="small"
                   disabled={timeView==='hours'}
                   onClick={() => changeTimeView()}>
                    <ArrowBackIcon />
                </IconButton>
              </Box>

              <TimeClock
                disabled={layoutField.AccessSetting_sys === 'read'}
                ampm={false}
                view={timeView}
                views={['hours', 'minutes']}
                value={dayjs(selectedDate)}
                onChange={(newCalendarValue: any) => changeTime(newCalendarValue)}
              />
            </Box>
            <Box
               sx={{display: "flex",
                    justifyContent: "flex-end"}}
            >
              <Button
                 size="small"
                 onClick={() => closeCalendar()}
                 variant='contained'
              >
                  <CheckIcon />
              </Button>
            </Box>
          </Popover>
      </>
    );

};
